import request from "@/utils/request";
// 微服务获取token
export function getToken(data) {
  return request({
    url: "/token",
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    data: data
  });
}
// 微服务路由
export function queryQuotaInfo(data) {
  return request({
    url: "/gateway/queryQuotaInfo",
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    data: data
  });
}

// 微服务路由
export function queryBkydInfo(data) {
  return request({
    url: "/gateway/queryBkydInfo",
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/microService.js